import { postGeneralStocks } from '@/fsd/entities/remains/api/postGeneralStocks';
import { TitledTablePage } from '@/fsd/pages/layouts/titled-table-page';
import EmptyData from '@/fsd/shared/ui/EmptyData/EmptyData';
import Loader from '@/fsd/shared/ui/Loader/Loader';
import { useQuery } from '@tanstack/react-query';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import RemainsStore from '../../model/store/RemainsStore';
import RemainsFilters from '../RemainsFilters/RemainsFilters';
import { RemainsPagination } from '../RemainsPagination/RemainsPagination';
import RemainsTable from '../RemainsTable/RemainsTable';

const Remains = observer(() => {
  const navigate = useNavigate();
  const location = useLocation();

  const { page, pageSize, filters, init } = RemainsStore;

  useEffect(() => {
    init(navigate, location.search);
  }, [navigate, location.search]);

  const { isFetching, data } = useQuery({
    queryKey: ['general-stocks', page, pageSize, JSON.stringify(filters)],
    queryFn: () => postGeneralStocks({ page, limit: pageSize, filters }),
  });

  useEffect(() => {
    if (data?.data.warehouses_dict) {
      RemainsStore.setWarehouses(data.data.warehouses_dict);
    }
  }, [data]);

  return (
    <TitledTablePage title="Остатки">
      <RemainsFilters />

      {isFetching ? (
        <EmptyData desc={<Loader />} />
      ) : !data || data.meta.total === 0 ? (
        <EmptyData desc="Не найдено остатков!" />
      ) : (
        <>
          <RemainsTable data={data.data} />
          <RemainsPagination totalPages={data.meta.total_pages} />
        </>
      )}
    </TitledTablePage>
  );
});

export default Remains;
